import React from "react";
import ClosedIpoClient from "./ClosedIpoClient";
import { getIpoListData } from "../../services/TradingMallService";
import { MAINBOARD, SME } from "../IpoList/IpoListConstants";
import { IpoAuthoringDataType } from "../IpoBase/IpoBaseAuthoringType";
import ConditionalSubtext from "../MarketInsigtsHeading/conditionalSubtext";

const DEFAULT_CLOSED_IPO_TITLE = "Closed IPOs";
const DEFAULT_CLOSED_IPO_SUBTEXT =
  "Browse IPOs that recently closed for subscription. Check final subscription numbers, allotment timelines, and expected listing dates to track your investments or plan future entries.";

const DEFAULT_PAGINATION_LIMIT = 20;
const DEFAULT_IPO_TYPE = "closed";

type ClosedIpoAuthoringData = IpoAuthoringDataType & {
  ipoSubtext?: string;
};

const ClosedIPOServer = async (authoringData: ClosedIpoAuthoringData = {}) => {
  const ipoTitle = authoringData?.ipoTitle ?? DEFAULT_CLOSED_IPO_TITLE;
  const ipoSubtext = authoringData?.ipoSubtext ?? DEFAULT_CLOSED_IPO_SUBTEXT;
  const HeadingTag = authoringData?.headingLevel === "h2" ? "h2" : "h1";
  const parsedPaginationLimit = Number.parseInt(
    authoringData?.paginationLimit ?? `${DEFAULT_PAGINATION_LIMIT}`,
    10,
  );
  const paginationLimit =
    Number.isFinite(parsedPaginationLimit) && parsedPaginationLimit > 0
      ? parsedPaginationLimit
      : DEFAULT_PAGINATION_LIMIT;
  const ipoType = authoringData?.ipoType ?? DEFAULT_IPO_TYPE;

  const [mainboardInitial, smeInitial] = await Promise.all([
    getIpoListData({
      ipoType,
      limit: paginationLimit,
      page: 1,
      subType: MAINBOARD,
    }),
    getIpoListData({
      ipoType,
      limit: paginationLimit,
      page: 1,
      subType: SME,
    }),
  ]);

  return (
    <section className="flex flex-col gap-[12px] lg:pl-[144px] pl-[16px] pr-[16px] lg:pt-[24px] pt-[12px] pb-[12px]">
       <HeadingTag className="font-medium font-rubik ipo-title text-[18px] md:text-[20px] leading-none  text-[#1A1A1A]">
         {ipoTitle}
       </HeadingTag>
       <ConditionalSubtext subtext={ipoSubtext} className="max-w-[727px] text-[#1A1A1A]" />
      <ClosedIpoClient
        mainboardInitial={mainboardInitial}
        smeInitial={smeInitial}
        authoringData={authoringData}
      />
    </section>
  );
};

export default ClosedIPOServer;